module.exports = {"620881001":"东华街道","620881100":"东华镇","620881101":"安口镇","620881102":"西华镇","620881103":"马峡镇","620881104":"策底镇","620881105":"上关镇","620881106":"河西镇","620881201":"神峪乡","620881202":"山寨乡","620881204":"砚峡乡","620881400":"石堡子开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620881.json
// module id = 2931
// module chunks = 0